<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <!--page content-->
            <div class="admin-page-content">
                <div class="page-title-container">
                    <div class="page-name">{{pageTitle}}</div>
                    <button v-if="loginUserRoleId == 1 || loginUserRoleId == 2" type="button" id="cancelAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack"><span>Back</span></button>
                </div>
                <!--Forms-->
                <div class="forms-container default-bx-shadow responsive-forms-container">
                    <div class="row no-margin">
                        <!-- Requestor Name -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Requestor Name :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <!-- <input type="text" maxlength="190" class="form-control" v-model="requestorName" id="requestorName" placeholder="Enter Requestor Name" name="requestorName"> -->
                                <span class="form-control">{{requestorName}}</span>
                                <!-- <div class="help is-danger">{{requestorNameError}}</div> -->
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <!-- Department -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Department :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="departmentId" name="departmentId"
                                    label="text"
                                    @input="changedValueDepartment"
                                    :options="departmentArr" :clearable=false placeholder="Select Department">
                                </v-select>
                                <div class="help is-danger">{{departmentIdError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <template v-if="!isHideLocationDropDown">
                            <!-- Location -->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">Location :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="location" name="location"
                                        label="name" placeholder="Select Location"
                                        @input="location_error = ''"
                                        :options="location_arr" :clearable=false>
                                    </v-select>
                                    <div class="help is-danger">{{location_error}}</div>
                                    <div class="requiredstar">*</div>
                                </div>
                            </div>
                        </template>
                        <!-- Vendor -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Vendor :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="vendorId" name="vendorId"
                                    label="text"
                                    @input="changedValueVendor"
                                    :options="vendorIdArr" :clearable=false placeholder="Select Vendor">
                                </v-select>
                                <div class="help is-danger">{{vendorIdError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <template v-if="isHideLocationDropDown">
                            <div class="col-6 forms-block">
                            </div>
                        </template>
                        <template v-for="(supplier, index) in ppeOrderArr">
                            <div :key="'description ' + index" class="col-5 forms-block">
                                <div class="">
                                    <div class="form-label">Description :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <!-- <input type="text" @input="supplier.descriptionError = ''" maxlength="190" class="form-control" v-model="supplier.description" id="description" name="description"> -->
                                    <v-select v-model="supplier.description" name="description"
                                        label="text"
                                        @input="changedValueDescription(supplier.description, index)"
                                        :options="supplier.descriptionArr" :clearable=false placeholder="Select Description">
                                    </v-select>
                                    <div class="help is-danger">{{supplier.descriptionError}}</div>
                                    <div class="requiredstar">*</div>
                                </div>
                            </div>
                            <div :key="'Unit of Measure Code ' + index" class="col-2 forms-block">
                                <div class="">
                                    <div class="form-label">Unit of Measure Code :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <!-- <span class="form-control">{{supplier.unitMeasureCode}}</span> -->
                                    <input type="text" @input="supplier.unitMeasureCodeError = ''" maxlength="190" class="form-control" v-model="supplier.unitMeasureCode" id="unitMeasureCode" name="unitMeasureCode">
                                    <div class="help is-danger">{{supplier.unitMeasureCodeError}}</div>
                                    <div class="requiredstar">*</div>
                                </div>
                            </div>
                            <div :key="'Item No ' + index" class="col-3 forms-block">
                                <div class="">
                                    <div class="form-label">Item No :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <!-- <span class="form-control">{{supplier.itemNo}}</span> -->
                                    <input type="text" @input="supplier.itemNoError = ''" maxlength="190" class="form-control" v-model="supplier.itemNo" id="itemNo" name="itemNo">
                                    <div class="help is-danger">{{supplier.itemNoError}}</div>
                                    <div class="requiredstar">*</div>
                                </div>
                            </div>
                            <div :key="'Quantity ' + index" class="col-1 forms-block">
                                <div class="">
                                    <div class="form-label">Quantity :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input type="text" @input="supplier.quantityError = ''" maxlength="190" class="form-control" v-model="supplier.quantity" id="quantity" name="quantity">
                                    <div class="help is-danger">{{supplier.quantityError}}</div>
                                    <div class="requiredstar">*</div>
                                </div>
                            </div>
                            <template v-if="ppeOrderArr.length == (index + 1) && plusCountSupplier != 0">
                                <div :key="'plus ' + index" style="margin-top: 28px;" class="col-1 forms-block">
                                    <button type="button" v-on:click="addNewDocumentSupplier(supplier, index)" class="btn btn-success">
                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </template>
                            <template v-else>
                                <div :key="'close ' + index" style="margin-top: 28px;" class="col-1 forms-block">
                                    <button type="button" v-on:click="removeSupplierDocument(supplier, index)" class="btn btn-danger">
                                        <i class="fa fa-times" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </template>
                        </template>
                        <!-- Other -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label" for="other">Other :</div>
                            </div>
                            <div class="col-9 paddingleft0" style="padding-top: 8px;">
                                <input id="other" v-model="other" class="form-control" type="checkbox"/>
                            </div>
                        </div>
                        <div class="col-6 forms-block">
                            &nbsp;
                        </div>
                        <template v-if="showOtherOption">
                            <template v-for="(otherSup, otherIndex) in otherPPEOrderArr">
                                <div :key="'Other description ' + otherIndex" class="col-5 forms-block">
                                    <div class="">
                                        <div class="form-label">Description :</div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <input type="text" @input="otherSup.descriptionError = ''" maxlength="190" class="form-control" v-model="otherSup.description" id="description" name="description">
                                        <div class="help is-danger">{{otherSup.descriptionError}}</div>
                                        <!-- <div class="requiredstar">*</div> -->
                                    </div>
                                </div>
                                <div :key="'Other Unit of Measure Code ' + otherIndex" class="col-2 forms-block">
                                    <div class="">
                                        <div class="form-label">Unit of Measure Code :</div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <input type="text" @input="otherSup.unitMeasureCodeError = ''" maxlength="190" class="form-control" v-model="otherSup.unitMeasureCode" id="unitMeasureCode" name="unitMeasureCode">
                                        <div class="help is-danger">{{otherSup.unitMeasureCodeError}}</div>
                                        <!-- <div class="requiredstar">*</div> -->
                                    </div>
                                </div>
                                <div :key="'Other Item No ' + otherIndex" class="col-3 forms-block">
                                    <div class="">
                                        <div class="form-label">Item No :</div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <input type="text" @input="otherSup.itemNoError = ''" maxlength="190" class="form-control" v-model="otherSup.itemNo" id="itemNo" name="itemNo">
                                        <div class="help is-danger">{{otherSup.itemNoError}}</div>
                                        <!-- <div class="requiredstar">*</div> -->
                                    </div>
                                </div>
                                <div :key="'Other Quantity ' + otherIndex" class="col-1 forms-block">
                                    <div class="">
                                        <div class="form-label">Quantity :</div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <input type="text" @input="otherSup.quantityError = ''" maxlength="190" class="form-control" v-model="otherSup.quantity" id="quantity" name="quantity">
                                        <div class="help is-danger">{{otherSup.quantityError}}</div>
                                        <!-- <div class="requiredstar">*</div> -->
                                    </div>
                                </div>
                                <template v-if="otherPPEOrderArr.length == (otherIndex + 1) && plusCountOtherSupplier != 0">
                                    <div :key="'Other plus ' + otherIndex" style="margin-top: 28px;" class="col-1 forms-block">
                                        <button type="button" v-on:click="addNewDocumentOtherSupp(otherSup, otherIndex)" class="btn btn-success">
                                            <i class="fa fa-plus" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </template>
                                <template v-else>
                                    <div :key="'Other close ' + otherIndex" style="margin-top: 28px;" class="col-1 forms-block">
                                        <button type="button" v-on:click="removeOtherSuppDocument(otherSup, otherIndex)" class="btn btn-danger">
                                            <i class="fa fa-times" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </template>
                            </template>
                        </template>
                        <div class="clearfix"></div>
                        <div class="mr-17 pb-12 float-l">
                            <button v-if="loginUserRoleId == 1 || loginUserRoleId == 2" type="button" id="cancelAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack"><span>Cancel</span></button>
                            <button type="submit" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="addPPEOrder('save')"><span id="createAttachment">Save</span></button>
                        </div>

                    </div>
                </div>
                <!-- Forms -->
            </div>
            <!--page content-->
        </div>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import Footer from "@/components/partials/Footer";
    import vSelect from 'vue-select';
    import {HTTP, HTTPGUZZLE} from '../../../http-common.js';
    import {commonMixins} from '../../../mixins/commonMixins';
    import EventBus from "../../../components/event-bus";
    var self;
    Vue.component('v-select', vSelect)
    Vue.component("app-footer", Footer);
    export default {
        name: 'AddUpdatePPEOrderSupplies',
        mixins: [commonMixins],
        data() {
            return {
                //user_role: 0,
                pageTitle: 'PPE Order',
                edit_id: 0,
                requestorName: "",
                requestorNameError: "",
                departmentArr: [ 
                    {
                        text: 'Body Shop',
                        value: 'Body Shop',
                    },
                    {
                        text: 'Central Ops.',
                        value: 'Central Ops.',
                    },
                    {
                        text: 'Service',
                        value: 'Service',
                    },
                ],
                departmentId: "",
                departmentIdError: "",
                location: "",
                location_arr: [],
                location_error: "",
                vendorId: {text: 'Grainger', value: 'Grainger'},
                vendorIdArr: [
                     {
                        text: 'Grainger',
                        value: 'Grainger'
                    },
                   
                    {
                        text: 'Uline',
                        value: 'Uline'
                    },
                    {
                        text: 'UniFirst',
                        value: 'UniFirst'
                    },
                ],
                vendorIdError: "",
                ppeOrderArr: [
                    {
                        description: "",
                        descriptionArr: [],
                        descriptionError: "",
                        unitMeasureCode: "",
                        unitMeasureCodeError: "",
                        itemNo: "",
                        itemNoError: "",
                        quantity: "",
                        quantityError: "",
                    },
                ],
                tempPPEOrderObject: {
                    description: "",
                    descriptionArr: [],
                    descriptionError: "",
                    unitMeasureCode: "",
                    unitMeasureCodeError: "",
                    itemNo: "",
                    itemNoError: "",
                    quantity: "",
                    quantityError: "",
                },
                plusCountSupplier: 9,
                otherPPEOrderArr: [
                    {
                        description: "",
                        descriptionError: "",
                        unitMeasureCode: "",
                        unitMeasureCodeError: "",
                        itemNo: "",
                        itemNoError: "",
                        quantity: "",
                        quantityError: "",
                    },
                ],
                otherTempPPEOrderObject: {
                    description: "",
                    descriptionError: "",
                    unitMeasureCode: "",
                    unitMeasureCodeError: "",
                    itemNo: "",
                    itemNoError: "",
                    quantity: "",
                    quantityError: "",
                },
                plusCountOtherSupplier: 4,

                managerEmail: "",
                loginUserRoleId: 1,
                bodyShopLocationArr: [],
                serviceLocationArr: [],
                indexDes: 0,
                other: 0,
                showOtherOption: false,
                isHideLocationDropDown: false,
            }
        },
        watch: {
            location: function(location) {
                self.managerEmail = "";
                if (location != null || location.id) {
                    for(var index = 0;index<self.location_arr.length;index++) {
                        var obj = self.location_arr[index];
                        if(obj['id'] == location.id) {
                            self.managerEmail = obj['manager_email'];
                        }
                    }
                }
            },
            other: function(other) {
                self.showOtherOption = false;
                self.otherPPEOrderArr = [];
                self.otherPPEOrderArr = [
                    {
                        description: "",
                        descriptionError: "",
                        unitMeasureCode: "",
                        unitMeasureCodeError: "",
                        itemNo: "",
                        itemNoError: "",
                        quantity: "",
                        quantityError: "",
                    },
                ];
                if(other) {
                    self.showOtherOption = true;
                }
            }
        },
        beforeMount: function () {
            self = this;
        },
        created: function () {
        },
        mounted: function () {
            self.menuActive("PPEOrderSupploes");
            var userObj = localStorage.getItem('user_obj');
            if (userObj && userObj != null) {
                var userJson = JSON.parse(userObj);
                self.loginUserRoleId = userJson['role'].system_id;
                self.requestorName = self.formatString(userJson['first_name'] + " " + userJson['last_name']);
            }
            self.loadLocation();
            self.loadBodyShopLocation();
            self.loadItemMapperData();
        },
        methods: {
            buttonBack() {
                self.$router.push('/ppe/order/supplies/list');
            },
            changedValueDepartment: function(department) {
                self.departmentIdError = "";
                self.location_arr = [];
                self.location = "";
                self.isHideLocationDropDown = false;
                if (department != 'undefined' && department.value) {
                    self.location_arr = self.serviceLocationArr;
                    if(department.value == 'Body Shop') {
                        self.location_arr = self.bodyShopLocationArr;
                        self.location_arr = self.location_arr.sort((a, b) => { return a.name.localeCompare(b.name);});
                    }
                    if(department.value == 'Central Ops.') {
                        self.isHideLocationDropDown = true;
                    }
                }
            },
            changedValueDescription: function(description, desIndex) {
                self.ppeOrderArr[desIndex].descriptionError = '';
                /* self.ppeOrderArr[desIndex].unitMeasureCode = description.unit_of_measure_code;
                self.ppeOrderArr[desIndex].itemNo = description.item_no;
                self.ppeOrderArr[desIndex].quantity = ""; */
            },
            removeOtherSuppDocument: function(object, index) {
                if(self.plusCountOtherSupplier <= 4 ) {
                    self.plusCountOtherSupplier = self.plusCountOtherSupplier + 1;
                    self.otherPPEOrderArr.splice(index, 1);
                }
            },
            addNewDocumentOtherSupp: function(object, index) {
                var error = true;
                self.otherPPEOrderArr[index].descriptionError = "";
                self.otherPPEOrderArr[index].unitMeasureCodeError = "";
                self.otherPPEOrderArr[index].itemNoError = "";
                self.otherPPEOrderArr[index].quantityError = "";

                if(!self.otherPPEOrderArr[index].description) {
                    self.otherPPEOrderArr[index].descriptionError = "Enter Description";
                    if (error) {
                        error = false;
                    }
                }
                if(!self.otherPPEOrderArr[index].unitMeasureCode) {
                    self.otherPPEOrderArr[index].unitMeasureCodeError = "Enter Unit Measure Code";
                    if (error) {
                        error = false;
                    }
                }
                if(!self.otherPPEOrderArr[index].itemNo) {
                    self.otherPPEOrderArr[index].itemNoError = "Enter Item No";
                    if (error) {
                        error = false;
                    }
                }
                if (!self.otherPPEOrderArr[index].quantity) {
                    self.otherPPEOrderArr[index].quantityError = "Please enter Quantity";
                    if (error) {
                        error = false;
                    }
                } else if (self.otherPPEOrderArr[index].quantity && !self.numberFormateValidation(self.otherPPEOrderArr[index].quantity)) {
                    self.otherPPEOrderArr[index].quantityError = "Please enter numeric value";
                    if (error) {
                        error = false;
                    }
                }
                if (self.otherPPEOrderArr[index].quantity && self.numberFormateValidation(self.otherPPEOrderArr[index].quantity) && self.otherPPEOrderArr[index].quantity > 1000) {
                    self.otherPPEOrderArr[index].quantityError = "Max Quantity is 1000";
                    if (error) {
                        error = false;
                    }
                }
                if(error) {
                    self.plusCountOtherSupplier = self.plusCountOtherSupplier - 1;
                    self.otherPPEOrderArr.push(Vue.util.extend({}, self.otherTempPPEOrderObject));
                }
            },
            changedValueVendor: function(vendor) {
                self.vendorIdError = "";
                /* self.ppeOrderArr = [];
                self.ppeOrderArr = [
                    {
                        description: "",
                        descriptionArr: [],
                        descriptionError: "",
                        unitMeasureCode: "",
                        unitMeasureCodeError: "",
                        itemNo: "",
                        itemNoError: "",
                        quantity: "",
                        quantityError: "",
                    },
                ];
                self.plusCountSupplier = 9;
                self.indexDes = 0; */
            },
            loadItemMapperData: function() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("token")},
                };
                HTTP.get("/ppe/item/mapper/get", config)
                    .then(function (response) {
                        self.ppeOrderArr[0].descriptionArr = response.data.content;
                        self.tempPPEOrderObject['descriptionArr'] = response.data.content;
                    })
                    .catch(function (err) {
                        self.catchHandler(err, function () {});
                    });
            },
            changedValue: function () {
            },
            loadBodyShopLocation: function() {
                var config = {
                    params: {
                        slug: "vvg-au",
                        department_id: 8
                    }
                };
                HTTPGUZZLE.get("/api/v1/getlocations", config)
                    .then(function (response) {
                        self.bodyShopLocationArr = response.data.locations;
                        if(self.bodyShopLocationArr && self.bodyShopLocationArr.length > 0) {
                            // for(var index = 0; index < self.bodyShopLocationArr.length; index++) {
                            //     var objLocation = self.bodyShopLocationArr[index];
                            //     if(objLocation['name'] == 'Hope Mills Bodyshop, NC' || objLocation['id'] == 76) {
                            //         self.bodyShopLocationArr.splice(index, 1);
                            //     }
                            //     /* if(objLocation['name'] == 'Whittier, CA' || objLocation['id'] == 12) {
                            //         self.bodyShopLocationArr[index]['manager_email'] += ",psegala@vvgtruck.com";
                            //     }
                            //     if(objLocation['name'] == 'Las Vegas, NV' || objLocation['id'] == 3) {
                            //         self.bodyShopLocationArr[index]['manager_email'] += ",athomason@vvgtruck.com";
                            //     }
                            //     if(objLocation['name'] == 'Sparks, NV' || objLocation['id'] == 5) {
                            //         self.bodyShopLocationArr[index]['manager_email'] += ",jtorres@vvgtruck.com";
                            //     } */
                            // }
                            self.bodyShopLocationArr = self.bodyShopLocationArr.sort((a, b) => { return a.name.localeCompare(b.name);});
                        }
                        // console.log(JSON.stringify(self.bodyShopLocationArr));
                    })
                    .catch(function (err) {
                        self.catchHandler(err, function () {});
                    });
            },
            loadLocation: function() {
                var config = {
                    params: {
                        slug: "vvg-au",
                        department_id: 2
                    }
                };
                self.showLoader();
                HTTPGUZZLE.get("/api/v1/getlocations", config)
                        .then(function (response) {
                            // self.location_arr = response.data.locations;
                            self.serviceLocationArr = response.data.locations;
                            self.serviceLocationArr = self.serviceLocationArr.sort((a, b) => { return a.name.localeCompare(b.name);});
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            self.catchHandler(err, function () {});
                        });
            },
            removeSupplierDocument: function(object, index) {
                if(self.plusCountSupplier <= 9 ) {
                    self.indexDes -= 1;
                    self.plusCountSupplier = self.plusCountSupplier + 1;
                    self.ppeOrderArr.splice(index, 1);
                }
            },
            addNewDocumentSupplier: function(object, index) {
                var error = true;
                self.ppeOrderArr[index].descriptionError = "";
                self.ppeOrderArr[index].unitMeasureCodeError = "";
                self.ppeOrderArr[index].itemNoError = "";
                self.ppeOrderArr[index].quantityError = "";

                if (self.ppeOrderArr[index].description == null || !self.ppeOrderArr[index].description.value) {
                    self.ppeOrderArr[index].descriptionError = "Select Description";
                    if (error) {
                        error = false;
                    }
                }
                if(!self.ppeOrderArr[index].unitMeasureCode) {
                    self.ppeOrderArr[index].unitMeasureCodeError = "Enter Unit Measure Code";
                    if (error) {
                        error = false;
                    }
                }
                if(!self.ppeOrderArr[index].itemNo) {
                    self.ppeOrderArr[index].itemNoError = "Enter Item No";
                    if (error) {
                        error = false;
                    }
                }
                if (!self.ppeOrderArr[index].quantity) {
                    self.ppeOrderArr[index].quantityError = "Please enter Quantity";
                    if (error) {
                        error = false;
                    }
                } else if (self.ppeOrderArr[index].quantity && !self.numberFormateValidation(self.ppeOrderArr[index].quantity)) {
                    self.ppeOrderArr[index].quantityError = "Please enter numeric value";
                    if (error) {
                        error = false;
                    }
                }
                if (self.ppeOrderArr[index].quantity && self.numberFormateValidation(self.ppeOrderArr[index].quantity) && self.ppeOrderArr[index].quantity > 1000) {
                    self.ppeOrderArr[index].quantityError = "Max Quantity is 1000";
                    if (error) {
                        error = false;
                    }
                }
                if(error) {
                    self.indexDes += 1;
                    self.plusCountSupplier = self.plusCountSupplier - 1;
                    self.ppeOrderArr.push(Vue.util.extend({}, self.tempPPEOrderObject));
                }
            },
            checkForm: function () {
                var checked = true;
                var index = 0;
                self.location_error = "";
                self.departmentIdError = "";
                self.requestorNameError = "";
                self.vendorIdError = "";
                self.descriptionError = "";
                self.unitMeasureCodeError = "";
                self.itemNoError = "";
                self.ppeOrderArr[index].descriptionError = "";
                self.ppeOrderArr[index].unitMeasureCodeError = "";
                self.ppeOrderArr[index].itemNoError = "";
                self.otherPPEOrderArr[index].descriptionError = "";
                self.otherPPEOrderArr[index].unitMeasureCodeError = "";
                self.otherPPEOrderArr[index].itemNoError = "";
                self.otherPPEOrderArr[index].quantityError = "";

                if (self.departmentId == null || !self.departmentId.value) {
                    self.departmentIdError = "Select Department";
                    if (checked) {
                        checked = false;
                    }
                }
                if(!self.isHideLocationDropDown) {
                    if (self.location == null || !self.location.id) {
                        self.location_error = "select Location";
                        if (checked) {
                            checked = false;
                        }
                    }
                }
                if (self.vendorId == null || !self.vendorId.value) {
                    self.vendorIdError = "select vendor";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.requestorName) {
                    self.requestorNameError = "Please enter requestor name";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.ppeOrderArr[index].description == null || !self.ppeOrderArr[index].description.value) {
                    self.ppeOrderArr[index].descriptionError = "Select Description";
                    if (checked) {
                        checked = false;
                    }
                }
                if(!self.ppeOrderArr[index].unitMeasureCode) {
                    self.ppeOrderArr[index].unitMeasureCodeError = "Enter Unit Measure Code";
                    if (checked) {
                        checked = false;
                    }
                }
                if(!self.ppeOrderArr[index].itemNo) {
                    self.ppeOrderArr[index].itemNoError = "Enter Item No";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.ppeOrderArr[index].quantity) {
                    self.ppeOrderArr[index].quantityError = "Please enter Quantity";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.ppeOrderArr[index].quantity && !self.numberFormateValidation(self.ppeOrderArr[index].quantity)) {
                    self.ppeOrderArr[index].quantityError = "Please enter numeric value";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.ppeOrderArr[index].quantity && self.numberFormateValidation(self.ppeOrderArr[index].quantity) && self.ppeOrderArr[index].quantity > 1000) {
                    self.ppeOrderArr[index].quantityError = "Max Quantity is 1000";
                    if (checked) {
                        checked = false;
                    }
                }
                if(self.other) {
                    /* if(!self.otherPPEOrderArr[index].description) {
                        self.otherPPEOrderArr[index].descriptionError = "Enter Description";
                        if (checked) {
                            checked = false;
                        }
                    }
                    if(!self.otherPPEOrderArr[index].unitMeasureCode) {
                        self.otherPPEOrderArr[index].unitMeasureCodeError = "Enter Unit Measure Code";
                        if (checked) {
                            checked = false;
                        }
                    }
                    if(!self.otherPPEOrderArr[index].itemNo) {
                        self.otherPPEOrderArr[index].itemNoError = "Enter Item No";
                        if (checked) {
                            checked = false;
                        }
                    } */
                }
                return checked;
            },
            addPPEOrder(flag) {
                setTimeout(() => {
                    if (self.checkForm()) {
                        var config = {
                            headers: {Authorization: "Bearer " + localStorage.getItem("token")},
                        };
                        var fields = {
                            id: self.edit_id,
                            manager_email: self.managerEmail,
                            departmentName: self.departmentId.value,
                            location_id: !self.isHideLocationDropDown ? self.location.id : 0,
                            location: !self.isHideLocationDropDown ? self.location.name : "",
                            requestor_name: self.requestorName,
                            vendor_id: self.vendorId.value,
                            ppeOrderArr: self.ppeOrderArr,
                            otherPPEOrderArr: self.otherPPEOrderArr,
                            other_option: self.other,
                        };
                        // console.log(JSON.stringify(fields));return false;
                        self.showLoader();
                        HTTP.post("/ppe/order/add/update", fields, config)
                            .then(function (response) {
                                if (response.data.status == "success") {
                                    self.showSAlert(response.data.message, 'success');
                                    if(self.loginUserRoleId == 1 || self.loginUserRoleId == 2) {
                                        self.buttonBack();
                                    } else {
                                        self.edit_id = 0;
                                        self.managerEmail = '';
                                        self.departmentId = '';
                                        self.location = '';
                                        self.vendorId = '';
                                        self.vendorId = {text: 'Grainger', value: 'Grainger'};
                                        self.ppeOrderArr = [];
                                        self.ppeOrderArr = [
                                            {
                                                description: "",
                                                descriptionArr: [],
                                                descriptionError: "",
                                                unitMeasureCode: "",
                                                unitMeasureCodeError: "",
                                                itemNo: "",
                                                itemNoError: "",
                                                quantity: "",
                                                quantityError: "",
                                            },
                                        ];
                                        self.plusCountSupplier = 9;
                                        self.indexDes = 0;
                                        self.other = 0;
                                        self.showOtherOption = false;
                                        self.otherPPEOrderArr = [];
                                        self.otherPPEOrderArr = [
                                            {
                                                description: "",
                                                descriptionError: "",
                                                unitMeasureCode: "",
                                                unitMeasureCodeError: "",
                                                itemNo: "",
                                                itemNoError: "",
                                                quantity: "",
                                                quantityError: "",
                                            },
                                        ];
                                        self.plusCountOtherSupplier = 4;
                                        self.isHideLocationDropDown = false;
                                        // self.requestorName = '';
                                    }
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                self.hideLoader();
                                self.catchHandler(err, function () {});
                            });
                    }
                }, 200);
            },
            formatString: function (data) {
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            numberFormateValidation : function (inputtxt) {
                var valid = !/^\s*$/.test(inputtxt) && !isNaN(inputtxt);
                return valid;
            },
        }
    };
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Forms/PPEOrderSupplies/AddUpdatePPEOrderSupplies.vue